(function() {
  'use strict';
  
  function removeAnnouncementSticky() {
    // Sélectionne la barre d'annonce
    const announcementBar = document.querySelector('.announcement-bar-section');
    const utilityBar = document.querySelector('.utility-bar');
    
    if (announcementBar) {
      // Force position static (pas sticky, pas fixed)
      announcementBar.style.setProperty('position', 'static', 'important');
    }
    
    if (utilityBar) {
      utilityBar.style.setProperty('position', 'static', 'important');
    }
    
    // Assure que le header reste sticky en haut
    const headerSticky = document.querySelector('.shopify-section-header-sticky');
    if (headerSticky) {
      headerSticky.style.setProperty('position', 'sticky', 'important');
      headerSticky.style.setProperty('top', '0', 'important');
      headerSticky.style.setProperty('z-index', '40', 'important');
    }
    
    // Retire le padding-top du body qui compense les éléments fixes
    document.body.style.paddingTop = '0';
  }
  
  // Execute au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeAnnouncementSticky);
  } else {
    removeAnnouncementSticky();
  }
  
  // Re-execute après un court délai pour être sûr
  setTimeout(removeAnnouncementSticky, 100);
  setTimeout(removeAnnouncementSticky, 500);
  
})();